import { on } from 'delegated-events';

const fn = {
  init: () => {
    on('click', '.element-photodumpform [data-accordion-toggle]', (e) => {
      const accordionToggle = e.target;
      const accordionTarget = accordionToggle.getAttribute('data-accordion-toggle');
      const accordionContent = document.querySelector(`#${accordionTarget}`);

      if (!accordionContent) return;

      accordionToggle.classList.remove('rotate-180');

      if (!accordionContent.open) {
        accordionContent.style.height = '0';
        accordionContent.open = true;
        requestAnimationFrame(() => {
          accordionContent.style.height = `${accordionContent.scrollHeight}px`;
          accordionContent.style.opacity = 1;
          accordionToggle.style.transform = 'rotate(0deg)';
        });
      } else {
        accordionContent.style.height = `${accordionContent.scrollHeight}px`;
        requestAnimationFrame(() => {
          accordionContent.style.height = '0';
          accordionContent.style.opacity = 0;
          accordionToggle.style.transform = 'rotate(180deg)';

          setTimeout(() => {
            accordionContent.open = false;
            accordionContent.style.height = '';
          }, 500);
        });
      }
    });
  },
};

export default {
  can: () => document.querySelectorAll('.element-photodumpform').length,
  run: fn.init,
};
